// 用户账号信息
export const SET_USER_INFO = 'SET_USER_INFO'

export const UPDATE_CREDIT = 'UPDATE_CREDIT'

export const SET_X_AUTH = 'SET_X_AUTH'

export const ENABLE_JSSDK = 'ENABLE_JSSDK'
export const DISABLE_JSSDK = 'DISABLE_JSSDK'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js